import {
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  FormHelperText,
} from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";

const CheckboxGroup = ({ field }) => {
  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  const handleChangeCheckbox = (e) => {
    const fieldValue = getValues(field.id) || {};
    const { name, checked } = e.target;
    setValue(field.id, {
      ...fieldValue,
      [name]: checked,
    });
  };

  return (
    <Box>
      <Controller
        name={field.id}
        control={control}
        defaultValue={[]}
        rules={{
          required: field.required ? `${field.label} is required` : false,
        }}
        render={({ field: { value = {} } }) => (
          <FormControl
            error={!!errorMessage}
            component="fieldset"
            variant="standard"
          >
            <FormLabel
              sx={{ mb: 2, fontWeight: 500 }}
              required={field.required}
              component="legend"
            >
              {field.label}
            </FormLabel>
            <FormGroup>
              {field.options.map((option) => (
                <FormControlLabel
                  key={option.id}
                  control={
                    <Checkbox
                      checked={value[option.label]}
                      onChange={handleChangeCheckbox}
                      name={option.label}
                    />
                  }
                  label={option.label}
                />
              ))}
            </FormGroup>
            {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
          </FormControl>
        )}
      />
    </Box>
  );
};

export default CheckboxGroup;
